import React from 'react';
import { useTranslation } from 'react-i18next';
import Pill from 'components/Pill';
import Icon from 'components/Icon';
export default function SharedWithYouPill() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Pill, {
    background: "highlight"
  }, /*#__PURE__*/React.createElement(Icon, {
    vAlign: true,
    dimmed: true,
    name: "send",
    scale: 0,
    mr: "xxxs"
  }), t('shared_with_you'));
}